module.exports = {"440804001":"南调街道","440804002":"麻斜街道","440804100":"南三镇","440804101":"坡头镇","440804102":"乾塘镇","440804103":"龙头镇","440804104":"官渡镇","440804401":"湛江市坡头区官渡工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440804.json
// module id = 1999
// module chunks = 0